import { Link } from '@tanstack/react-router';

import logo from '@repo/media/logo/nljv/NorthernLights_RGB_Small_Teal.svg';

export function LogoLink({ onClick, vertical }: { onClick?: () => void; vertical?: boolean }) {
  return (
    <Link
      to="/"
      onClick={onClick}
      className={vertical
        ? 'flex items-center justify-center py-4 px-2'
        : 'flex items-center gap-2.5 h-full ml-1.5'}
    >
      <img className={vertical ? 'h-7' : 'h-6'} alt="Northern Lights" src={logo} />
      {!vertical && (
        <span className="font-semibold text-sm text-primary-800 whitespace-nowrap">
          Northern Lights
        </span>
      )}
    </Link>
  );
}
